'use strict';
(function(angular) {
  angular
    .module('activationApp.controllers')
    .controller('HeaderController', [
      '$scope',
      '$rootScope',
      function(
        $scope,
        $rootScope) {
        $scope.getTitle = function() {
          return $rootScope.reactivation ? "Reactivate" : "Activate";
        };
      }]);
})(angular);

